import { Query } from "@datorama/akita";
import { injectable } from "tsyringe";

import ReviewsProductInfoStore, {
    ReviewsProductInfoState,
} from "../stores/ReviewsProductInfoStore";

@injectable()
class ReviewsProductInfoQuery extends Query<ReviewsProductInfoState> {
    constructor(protected store: ReviewsProductInfoStore) {
        super(store);
    }

    productInfo$ = this.select((state) => state.productInfo);
}

export default ReviewsProductInfoQuery;
